import { render, staticRenderFns } from "./DoKoPlayerInfo.vue?vue&type=template&id=0a865abd&scoped=true&"
import script from "./DoKoPlayerInfo.vue?vue&type=script&lang=ts&"
export * from "./DoKoPlayerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoPlayerInfo.vue?vue&type=style&index=0&id=0a865abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a865abd",
  null
  
)

/* custom blocks */
import block0 from "./DoKoPlayerInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports